import { Alert } from '@rocket/ui';
import { useEffect } from 'react';

type Severity = 'info' | 'warning' | 'success' | 'error';

export interface SnackbarCustomProps {
  severity?: Severity;
  msg: string | null;
  setMsg: (msg: string | null) => void;
  duration?: number;
}

export const SnackbarCustom = ({
  severity = 'warning',
  msg = null,
  setMsg,
  duration = 5,
}: SnackbarCustomProps) => {
  useEffect(() => {
    if (!msg) {
      return;
    }
    const id = window.setTimeout(() => setMsg(null), duration * 1000);
    return () => window.clearTimeout(id);
  }, [msg, duration, setMsg]);

  if (!msg) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 24,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1400,
        minWidth: 320,
        maxWidth: '90vw',
      }}
    >
      <Alert status={severity} onClose={() => setMsg(null)}>
        {msg}
      </Alert>
    </div>
  );
};
